import { ICombination } from '../../AssignResults/Context/AssignResults.context';

export const isStrokeplay = ({
  format: {
    format: { prefix }
  }
}: ICombination) => prefix === 'stroke';
